module.exports = __webpack_public_path__ + "static/media/leaf_2.fcce8a31.png";